import React from 'react'
import ReactDOM from 'react-dom/client'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// v8 ships its styles separately; must load before styles/tables.css overrides
import 'react-data-table-component/css'

import QueryProvider from 'app/providers/QueryProvider'
import App from 'app/App'

import 'styles/base.css'
import 'styles/typography.css'
import 'styles/forms.css'
import 'styles/buttons.css'
import 'styles/auth.css'
import 'styles/tables.css'
import 'styles/components.css'
import 'react-tippy/dist/tippy.css'
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <QueryProvider>
    <App />
    <ToastContainer />
  </QueryProvider>,
)
